import ExcelDownload from "../../../components/ExcelDownload";
import useUserInformation from "../../../hooks/useUserInformation";

function ExcelShipments({ params }) {
  const { isDistrictManger } = useUserInformation();

  const url = isDistrictManger
    ? "/district-manager/v1/shipments"
    : "/supervisor/v1/shipments";

  return <ExcelDownload params={{ excel: true, ...params }} url={url} />;
}

export default ExcelShipments;
